import React, { Suspense } from 'react';

import { Routes, Route, Navigate, useParams } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import { AuthProvider } from './contexts/AuthContext';

import { ThemeProvider } from './contexts/ThemeContext';

import Header from './components/Header';

import UserManagementPage from './components/UserManagementPage';

import RegisterPage from './components/RegisterPage';

import CabinetsSelectPage from './components/CabinetsSelectPage';

import AdminCabinetsClientsPage from './components/AdminCabinetsClientsPage';

import AdminPointAccesPage from './components/AdminPointAccesPage';

import ProtectedRoute from './components/ProtectedRoute';

import AdminRoute from './components/AdminRoute';

import ClientDetails from './components/ClientDetails';

import ClientCharges from './components/ClientCharges';

import ClientChargesListPrintPage from './components/ClientChargesListPrintPage';

import HomePage from './components/HomePage';

import RootEntry from './components/RootEntry';

import AllClientsPage from './components/AllClientsPage';

import SearchClientPage from './components/SearchClientPage';

import AddClientPage from './components/AddClientPage';

import HonorairesByDayPage from './components/HonorairesByDayPage';

import HonorairesByMonthPage from './components/HonorairesByMonthPage';

import HonorairesByYearPage from './components/HonorairesByYearPage';

import AllHonorairesPage from './components/AllHonorairesPage';

import DepensesBureauByBeneficiairePage from './components/DepensesBureauByBeneficiairePage';

import DepensesBureauByDayPage from './components/DepensesBureauByDayPage';

import DepensesBureauByMonthPage from './components/DepensesBureauByMonthPage';

import DepensesBureauByYearPage from './components/DepensesBureauByYearPage';

import AllDepensesBureauPage from './components/AllDepensesBureauPage';

import AllEtatBureauPage from './components/AllEtatBureauPage';

import EtatBureauByBeneficiairePage from './components/EtatBureauByBeneficiairePage';

import EtatBureauByDayPage from './components/EtatBureauByDayPage';

import EtatBureauByMonthPage from './components/EtatBureauByMonthPage';

import EtatBureauByYearPage from './components/EtatBureauByYearPage';

import FondClientChezCgmPage from './components/FondClientChezCgmPage';

import FondClientCgmEtatViewPage from './components/FondClientCgmEtatViewPage';

import ClientDepensesByDayPage from './components/ClientDepensesByDayPage';

import ClientDepensesByMonthPage from './components/ClientDepensesByMonthPage';

import ClientDepensesByYearPage from './components/ClientDepensesByYearPage';

import DepensesClientByDayPage from './components/DepensesClientByDayPage';

import DepensesClientByMonthPage from './components/DepensesClientByMonthPage';

import DepensesClientByYearPage from './components/DepensesClientByYearPage';

import ClientDepensesByBeneficiairePage from './components/ClientDepensesByBeneficiairePage';

import PrintReceiptPage from './components/PrintReceiptPage';

import EtatClientByDayPage from './components/EtatClientByDayPage';

import EtatClientByMonthPage from './components/EtatClientByMonthPage';

import EtatClientByYearPage from './components/EtatClientByYearPage';

import AllEtatClientPage from './components/AllEtatClientPage';

import AllDepensesPage from './components/AllDepensesPage';

import AllDepensesClientPage from './components/AllDepensesClientPage';

import EtatsCgmHonorairesPage from './components/EtatsCgmHonorairesPage';

import AllEtatClientsGlobalPage from './components/AllEtatClientsGlobalPage';

import EtatClientGlobalByDayPage from './components/EtatClientGlobalByDayPage';

import EtatClientGlobalByMonthPage from './components/EtatClientGlobalByMonthPage';

import EtatClientGlobalByYearPage from './components/EtatClientGlobalByYearPage';

import EtatClientParClientPage from './components/EtatClientParClientPage';

import AddDepenseBureauPage from './components/AddDepenseBureauPage';

import AddDepensePage from './components/AddDepensePage';

import PrintHistoryPage from './components/PrintHistoryPage';

import EtatClientPrintPage from './components/EtatClientPrintPage';

import EtatCgmPrintPage from './components/EtatCgmPrintPage';

import DepensesCgmPrintPage from './components/DepensesCgmPrintPage';

import DepensesClientListPrintPage from './components/DepensesClientListPrintPage';

import CaisseCgmPage from './components/CaisseCgmPage';

import AnciensRetraitsPage from './components/AnciensRetraitsPage';

import CartesBancairesPage from './components/CartesBancairesPage';

import TracabilitePage from './components/TracabilitePage';

import ArchivePage from './components/ArchivePage';

import ModulePlaceholderPage from './components/ModulePlaceholderPage';

import NHPage from './components/NHPage';

import AdminDashboard from './components/AdminDashboard';

import CgmModuleLayoutOutlet from './components/layout/CgmModuleLayoutOutlet';



const TailAdminStyleDashboard = React.lazy(() => import('./components/TailAdminStyleDashboard'));



const dashboardFallback = (

  <div className="p-4 text-center">Chargement du tableau de bord…</div>

);



// Composant de redirection pour /client/:id vers /client/:id/charges

function ClientRedirect() {

  const { id } = useParams();

  return <Navigate to={`/client/${id}/charges`} replace />;

}



function App() {

  return (

    <ThemeProvider>

      <AuthProvider>

        <div className="App">

        <Routes>

          <Route path="/login" element={<Navigate to="/" replace />} />

          <Route path="/register" element={<RegisterPage />} />

          <Route path="/regst" element={<RegisterPage />} />

          <Route path="/cabinets" element={
            <ProtectedRoute requireCabinet={false}>
              <CabinetsSelectPage />
            </ProtectedRoute>
          } />

          <Route path="/cabinets/clients" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <Navigate to="/cabinets/clients/actifs" replace />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/cabinets/clients/actifs" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <AdminCabinetsClientsPage key="clients-actifs" mode="actifs" />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/cabinets/clients/inactifs" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <AdminCabinetsClientsPage key="clients-inactifs" mode="inactifs" />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/cabinets/acces" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <AdminPointAccesPage />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/cabinets/acces/:cabinetId" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <AdminPointAccesPage />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/cabinets/users" element={
            <ProtectedRoute requireCabinet={false}>
              <AdminRoute redirectTo="/cabinets">
                <UserManagementPage adminShell />
              </AdminRoute>
            </ProtectedRoute>
          } />

          <Route path="/" element={<RootEntry />} />

          <Route path="/declarations" element={
            <ProtectedRoute>
              <ModulePlaceholderPage
                title="Déclarations"
                description="Échéances fiscales et sociales par dossier."
              />
            </ProtectedRoute>
          } />

          <Route path="/paie-personnel" element={
            <ProtectedRoute>
              <ModulePlaceholderPage
                title="Paie & personnel"
                description="Bulletins et charges du personnel."
              />
            </ProtectedRoute>
          } />

          {/* Module CGM : navbar + menu latéral sur toutes les pages du menu */}

          <Route element={<CgmModuleLayoutOutlet />}>

            <Route path="/dashboard" element={

              <AdminRoute>

                <Suspense fallback={dashboardFallback}>

                  <TailAdminStyleDashboard />

                </Suspense>

              </AdminRoute>

            } />

            <Route path="/admin/dashboard" element={

              <AdminRoute>

                <Suspense fallback={dashboardFallback}>

                  <TailAdminStyleDashboard />

                </Suspense>

              </AdminRoute>

            } />

            <Route path="/clients" element={<AllClientsPage />} />

            <Route path="/comptes" element={<UserManagementPage />} />

            <Route path="/honoraires/jour" element={<HonorairesByDayPage />} />

            <Route path="/honoraires/mois" element={<HonorairesByMonthPage />} />

            <Route path="/honoraires/annee" element={<HonorairesByYearPage />} />

            <Route path="/honoraires/tous" element={<AllHonorairesPage />} />

            <Route path="/depenses-client/jour" element={<DepensesClientByDayPage />} />

            <Route path="/depenses-client/mois" element={<DepensesClientByMonthPage />} />

            <Route path="/depenses-client/annee" element={<DepensesClientByYearPage />} />

            <Route path="/depenses-client/toutes" element={<AllDepensesClientPage />} />

            <Route path="/etat-client/tous" element={<AllEtatClientsGlobalPage />} />

            <Route path="/etat-client/jour" element={<EtatClientGlobalByDayPage />} />

            <Route path="/etat-client/mois" element={<EtatClientGlobalByMonthPage />} />

            <Route path="/etat-client/annee" element={<EtatClientGlobalByYearPage />} />

            <Route path="/etat-client/client" element={<EtatClientParClientPage />} />

            <Route path="/depenses-bureau/beneficiaire" element={<DepensesBureauByBeneficiairePage />} />

            <Route path="/depenses-bureau/ajouter" element={<AddDepenseBureauPage />} />

            <Route path="/depenses-cgm/ajouter" element={<AddDepensePage />} />

            <Route path="/depenses-bureau/jour" element={<DepensesBureauByDayPage />} />

            <Route path="/depenses-bureau/mois" element={<DepensesBureauByMonthPage />} />

            <Route path="/depenses-bureau/annee" element={<DepensesBureauByYearPage />} />

            <Route path="/depenses-bureau/toutes" element={<AllDepensesBureauPage />} />

            <Route path="/etat-bureau/beneficiaire" element={<EtatBureauByBeneficiairePage />} />

            <Route path="/etat-bureau/jour" element={<EtatBureauByDayPage />} />

            <Route path="/etat-bureau/mois" element={<EtatBureauByMonthPage />} />

            <Route path="/etat-bureau/annee" element={<EtatBureauByYearPage />} />

            <Route path="/etat-bureau/toutes" element={<AllEtatBureauPage />} />

            <Route path="/fond-client-cgm" element={<FondClientChezCgmPage />} />

            <Route path="/caisse-cgm" element={<CaisseCgmPage />} />

            <Route path="/caisse-cgm/anciens-retraits" element={<AnciensRetraitsPage />} />

            <Route path="/cartes-bancaires" element={<CartesBancairesPage />} />

            <Route path="/tracabilite" element={<TracabilitePage />} />

            <Route path="/archives" element={<ArchivePage />} />

            <Route path="/nh" element={<NHPage />} />

            <Route path="/client/:id/charges" element={<ClientCharges />} />

          </Route>



          {/* Routes Honoraires dans le contexte client (navbar client) */}

          <Route path="/client/:id/honoraires/jour" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <HonorairesByDayPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/honoraires/mois" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <HonorairesByMonthPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/honoraires/annee" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <HonorairesByYearPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/honoraires/tous" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <AllHonorairesPage />

              </div>

            </ProtectedRoute>

          } />



          {/* Route: Voir toutes les dépenses d'un client */}

          <Route path="/client/:id/depenses/toutes" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <AllDepensesPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/accueil" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <HomePage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/acceuil" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <HomePage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id" element={

            <ProtectedRoute>

              <ClientRedirect />

            </ProtectedRoute>

          } />

          <Route path="/client/:id/charges/print" element={

            <ProtectedRoute>

              <ClientChargesListPrintPage />

            </ProtectedRoute>

          } />

          <Route path="/search-client" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <SearchClientPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/add-client" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <AddClientPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/depenses-cgm/print" element={

            <ProtectedRoute>

              <DepensesCgmPrintPage />

            </ProtectedRoute>

          } />

          <Route path="/depenses-client/print" element={

            <ProtectedRoute>

              <DepensesClientListPrintPage />

            </ProtectedRoute>

          } />

          <Route path="/fond-client-cgm/etat" element={

            <ProtectedRoute>

              <FondClientCgmEtatViewPage />

            </ProtectedRoute>

          } />

          <Route path="/client/:id/depenses/jour" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <ClientDepensesByDayPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/depenses/mois" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <ClientDepensesByMonthPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/depenses/annee" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <ClientDepensesByYearPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/depenses/beneficiaire" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <ClientDepensesByBeneficiairePage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/print-receipt" element={

            <ProtectedRoute>

              <PrintReceiptPage />

            </ProtectedRoute>

          } />

          <Route path="/etat-client/print" element={

            <ProtectedRoute>

              <EtatClientPrintPage />

            </ProtectedRoute>

          } />

          <Route path="/etat-cgm/print" element={

            <ProtectedRoute>

              <EtatCgmPrintPage />

            </ProtectedRoute>

          } />

          <Route path="/client/:id/etat/jour" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <EtatClientByDayPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/etat/mois" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <EtatClientByMonthPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/etat/annee" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <EtatClientByYearPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/etat/toutes" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <AllEtatClientPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/client/:id/etat/honoraires" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <EtatsCgmHonorairesPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/print-history" element={

            <ProtectedRoute>

              <Header />

              <div className="container-fluid mt-4 app-page-content">

                <PrintHistoryPage />

              </div>

            </ProtectedRoute>

          } />

          <Route path="/dashboard-legacy" element={

            <ProtectedRoute>

              <AdminRoute redirectTo="/">

                <Header />

                <div className="container-fluid mt-4 app-page-content">

                  <AdminDashboard />

                </div>

              </AdminRoute>

            </ProtectedRoute>

          } />

          <Route path="*" element={<Navigate to="/clients" replace />} />

        </Routes>

      </div>

      </AuthProvider>

    </ThemeProvider>

  );

}



export default App;


